module.exports = __webpack_public_path__ + "static/media/headphone.7b6115c0.svg";